import React, { Component } from 'react'
import styled from 'styled-components'
import Label from 'components/UI/Label'
import Dropdown from 'components/UI/Dropdown'
import { AppointmentVariant, ConfigurationState } from 'ducks/references/types'
import { ThunkAction, MetadataObj, Dispatch, AppState } from 'store/types'
import { IForm } from '../EstimateForm'
import { Table } from 'components/UI/Table'
import { bindActionCreators } from 'redux'
import {
  fetchCpt4Codes,
  fetchServiceAreas
} from '../../../ducks/references/operations'
import { connect } from 'react-redux'
import { DropdownList } from 'components/common'
import DropMenu from 'components/UI/DropMenu'
import { MenuOption } from 'components/common/DropdownList'

const typeOptions = [
//  { value: AppointmentVariant.Appointment, label: 'Appointment Type' },
  { value: AppointmentVariant.CptCode, label: 'Procedure Code' }
]
export type PaymentStatuses = "PENDING" | "APPROVED" | "REJECTED" | "COMPLETED" | "REFUNDED"
interface State {
  appointmentType?: {
    value: string
    label: string
  }
}

interface Props {
  appointments?: object[]
  physicians?: any[]
  cpt4Codes?: object[]
  errors?: MetadataObj
  fetchAppointments?: (search?: string) => ThunkAction
  onChangeInput: (name: string, value: string | null) => void
  onRemoveElement?: (id: any) => void
  form: IForm
  fetchServiceAreas: (id: number) => void
  serviceAreas: any[]
  onScrollToBottom?: (appointmentType: string, searchText?: string) => void
  configuration?: ConfigurationState
}

class AppointmentInfo extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      appointmentType: typeOptions.find(
        item => item.value === AppointmentVariant.Appointment
      )
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (!prevProps.form.cpt4List && this.props.form.cpt4List) {
      if (this.props.form.cpt4List) {
        this.setState({
          appointmentType: typeOptions.find(
            item => item.value === AppointmentVariant.CptCode
          )
        })
      }
      if (this.props.form.payer) {
        this.props.fetchServiceAreas(this.props.form.payer.value)
      }
    }
  }
  componentDidMount(): void {
    // @ts-ignore
    const { fetchCpt4Codes, configuration, fetchAppointments, form } = this.props
    console.log("Values", form)
    if (
      configuration &&
      configuration.data.defaultEstimationDropdownType === 'cpt4'
    ) {
      this.setState({
        appointmentType: typeOptions.find(
          item => item.value === AppointmentVariant.CptCode
        )
      }
      )
      fetchCpt4Codes(form.payer.value, 300, undefined)
    } else {
      this.setState({
        appointmentType: typeOptions.find(
          item => item.value === AppointmentVariant.Appointment
        )
      })
      if (fetchAppointments) {
        fetchAppointments("")
      }
    }
  }

  onAppointmentTypeChange = (fieldName: string, value: any) => {
    const { onChangeInput } = this.props
    this.setState({ appointmentType: value })
    onChangeInput('appointmentIdSet', null)
    onChangeInput('cpt4IdSet', null)
    onChangeInput('cpt4List', null)
  }

  onSearch = (value: string) => {
    // @ts-ignore
    const { fetchCpt4Codes: fetchCpt4, fetchAppointments, form } = this.props
    const { appointmentType } = this.state
    if (appointmentType && appointmentType.label === 'Procedure Code') {
      console.log("onSearch", this.props, value)
      fetchCpt4(form.payer.value, undefined, value)
    } else {
      if (fetchAppointments) {
        fetchAppointments(value)
      }
    }
  }

  onScrollToBottom = (searchText: string) => {
    const { onScrollToBottom } = this.props
    const { appointmentType } = this.state
    if (onScrollToBottom) {
      if (searchText) {
        onScrollToBottom(
          appointmentType ? appointmentType.label : '',
          searchText
        )
      } else {
        onScrollToBottom(appointmentType ? appointmentType.label : '')
      }
    }
  }

  


  render() {
    const {
      onChangeInput,
      onRemoveElement,
      physicians,
      form: { appointmentIdSet, appointmentList, cpt4List, cpt4IdSet, physician, serviceCode },
      serviceAreas,
      configuration
    } = this.props
    const { appointmentType } = this.state
    const serviceAreasOptions = serviceAreas.map((item: any) => {
      return { value: item.id, label: item.hsCode }
    })
    const appointmentTypeValue = appointmentType && appointmentType.value
    const appointments =
      appointmentTypeValue === AppointmentVariant.Appointment
        ? this.props.appointments
        : appointmentTypeValue === AppointmentVariant.CptCode
          ? this.props.cpt4Codes
          : []
    const appointmentValue =
      appointmentTypeValue === AppointmentVariant.Appointment
        ? appointmentIdSet
        : appointmentTypeValue === AppointmentVariant.CptCode
          ? cpt4IdSet
          : []
    const appointmentName =
      appointmentTypeValue === AppointmentVariant.CptCode
        ? 'cpt4Id'
        : 'appointmentId'
    const appointmentPlaceholer =
      appointmentTypeValue === AppointmentVariant.CptCode
        ? 'Enter code or part of description'
        : 'Select Appointment Type'

    const headers = appointmentTypeValue === AppointmentVariant.CptCode
      ? {
        columns: [
          { name: 'Procedure Code' }
        ]
      }
      : {
        columns: [
          { name: 'Appointment Type' }
        ]
      }

    const appointmentListState = appointmentTypeValue === AppointmentVariant.Appointment
      ? appointmentList
      : appointmentTypeValue === AppointmentVariant.CptCode
        ? cpt4List
        : []
    const menuOptions: MenuOption[] = [
      {
        text: 'Delete',
        variant: 'text-danger',
        onClick: (id : any) => {
          onRemoveElement && onRemoveElement(id)
        }
      }
    ]

    const actionBlock = (id: any) => {
      return (
        <DropMenu target={<DotCircle/>}>
          <DropdownList menuOptions={menuOptions} id={id} />
        </DropMenu>
      )
    }
    const getActionsBlock = (id: any) => {
      return actionBlock(id)
    }

    const getTableBody = (appointmentListState: any[]) => {
      return appointmentListState.map((row: any, i) => {
        return {
          id: appointmentName === 'cpt4Id' ? row.cpt4Id : row.appointmentName,
          columns: [
            row.label,
          ],
          hoverColumns: [
          ]
        }
      })
    }

    return (
      <Form action={"javascript:void(0);"}>
        <div>
          <FormTitle>Procedure Information</FormTitle>
          <GroupBlock>
            <Label>Procedure Code</Label>
            <GroupItems>
              <Dropdown
                name={'appointmentType'}
                options={typeOptions}
                value={appointmentType}
                placeholder={'Appointment Type'}
                hideControl={true}
                onSelect={this.onAppointmentTypeChange}
              />
              <Dropdown
                name={appointmentName}
                options={appointments}
                value={appointmentValue}
                onInputChange={this.onSearch}


                placeholder={appointmentPlaceholer}
                onSelect={onChangeInput}
                onScrollToBottom={this.onScrollToBottom}
                isBigData={true}
              />
              {/*<BigDataDropdown*/}
              {/*  menuOptions={appointments}*/}
              {/*  placeholder={appointmentPlaceholer}*/}
              {/*  onSelect={onChangeInput}*/}
              {/*/>*/}
            </GroupItems>
          </GroupBlock>

          <Table
            header={headers}
            body={getTableBody(appointmentListState || [])}
            actionBlock={getActionsBlock}           
            isNew={true}
          />

          {configuration && configuration.data.physicianFieldEnabled && (
            <Dropdown
              name={'physician'}
              label={'Physician (optional)'}
              options={physicians}
              value={physician && physician.label ? physician : physician && physicians ? physicians.find(p => physician.value === p.value) : ''}
              onInputChange={this.onSearch}
              placeholder={'Select Physician'}
              onSelect={onChangeInput}
            />
          )}
          {configuration && configuration.data.serviceAreaFieldEnabled && (
            <Dropdown
              name={'serviceCode'}
              label={'Service Code (optional)'}
              options={serviceAreasOptions}
              value={serviceCode}
              onInputChange={this.onSearch}
              placeholder={'Select Service Code'}
              onSelect={onChangeInput}
            />
          )}
        </div>
      </Form>
    )
  }
}

// export default AppointmentInfo
const mapStateToProps = (state: AppState) => ({
  serviceAreas: state.references.serviceAreas.data.content
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      fetchServiceAreas,
      fetchCpt4Codes
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppointmentInfo)
const GroupBlock = styled.div``

const GroupItems = styled.div`
  position: relative;
  display: inline-flex;
  vertical-align: middle;
  width: 100%;

  > div:first-child {
    flex-basis: 110px;
    max-width: 40%;
  }

  > div {
    flex: 1 1 auto;
    max-width: 60%;
  }

  > div:not(:last-child) button {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  > div:not(:first-child) button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    margin-left: -1px;
  }
`

const FormTitle = styled.h2`
  margin-bottom: 2rem;
`
const Form = styled.form`
  max-width: 560px;
`
const DotCircle = styled.div`
  border-style: none;
  border-radius: 50%;
  color: #c1c1c1;
  font-weight: 600;
  font-size: 24px;
  font-family: serif;
  height: 26px;
  width: 26px;
  background-color: #e6eaf1;
  position: relative;
  cursor: pointer;
  padding: 0;
  margin: 0;
  min-width: auto;

  &:before {
    content: '...';
    position: absolute;
    bottom: 20%;
    left: 11%;
    right: 0;
  }

  :hover {
    background-color: #27b3f3;
    color: #fff;
  }
`
